import React from "react";
import { Card, Grid, styled } from "@mui/material";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import HeaderImage from "../Images/Header Image.png";
import icon_1 from "../Images/icon_1.png";
import icon_2 from "../Images/icon_2.png";
import icon_3 from "../Images/icon_3.png";
import icon_4 from "../Images/icon_4.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../style.css";

var settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const H1 = styled(Typography)((theme) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "56px;",
  lineHeight: "110%",
  letterSpacing: "-0.01em;",
  color: "#000000;",
}));

const H2 = styled(Typography)((theme) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "40px",
  lineHeight: "125%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const H3 = styled(Typography)(({ theme }) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "24px",
  lineHeight: "150%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const H4 = styled(Typography)(({ theme }) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "20px",
  lineHeight: "150%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const P = styled(Typography)(({ theme }) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "150%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

// const Btn = styled(Button)(({ theme }) => ({
//   padding: "5px 20px;",
//   border: "1px solid #559A95;",
//   backgroundColor: "#2B817B",
//   fontSize: "20px;",
//   fontWeight: "600",
//   borderRadius: "8px;",
//   color: "white",
// }));

function Our_Partner() {
  return (
    <>
      <Box sx={{ backgroundColor: "#F6F6F6;", padding: 5 }}>
        <Box sx={{ padding: 2, width: "100%" }}>
          <Slider {...settings}>
            <Card
              sx={{
                backgroundColor: "#ffff",
                borderRadius: "8px",
                mx: 1,
                padding: 2,
                width: "250px",
                height: { lg: "240px", md: "240px", sm: "310px", xs: "240px" },
                // border:"1px solid red"
              }}
            >
              <img src={icon_1} />
              <H4>
                400+ Catering Partner <br /> from different cities
              </H4>
              <P
                sx={{
                  fontSize: "14px",
                  color: "#545359;",
                  textAlign: "justify",
                }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum is simply dummy text of the printing and
                typesetting industry.{" "}
              </P>
            </Card>
            <Card
              sx={{
                backgroundColor: "#ffff",
                borderRadius: "8px",
                marginLeft: 0,
                padding: 2,
                width: "250px",
                height: { lg: "240px", md: "240px", sm: "310px", xs: "240px" },
              }}
            >
              <img src={icon_2} />
              <H4>
                1 million+ Eatcoast <br /> Customer
              </H4>
              <P
                sx={{
                  fontSize: "14px",
                  color: "#545359;",
                  textAlign: "justify",
                }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum is simply dummy text of the printing and
                typesetting industry.{" "}
              </P>
            </Card>
            <Card
              sx={{
                backgroundColor: "#ffff",
                borderRadius: "8px",
                marginLeft: 0,
                padding: 2,
                width: "284px",
                height: { lg: "240px", md: "240px", sm: "310px", xs: "240px" },
              }}
            >
              <img src={icon_3} />
              <H4>
                Create your own <br /> promotion
              </H4>
              <P
                sx={{
                  fontSize: "14px",
                  color: "#545359;",
                  textAlign: "justify",
                }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum is simply dummy text of the printing and
                typesetting industry.{" "}
              </P>
            </Card>
            <Card
              sx={{
                backgroundColor: "#ffff",
                borderRadius: "8px",
                marginLeft: 0,
                padding: 2,
                width: "284px",
                height: { lg: "240px", md: "240px", sm: "310px", xs: "240px" },
              }}
            >
              <img src={icon_4} />
              <H4>
                Fully integrated <br /> system
              </H4>
              <P
                sx={{
                  fontSize: "14px",
                  color: "#545359;",
                  textAlign: "justify",
                }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum is simply dummy text of the printing and
                typesetting industry.{" "}
              </P>
            </Card>
            <Card
              sx={{
                backgroundColor: "#ffff",
                borderRadius: "8px",
                marginLeft: 0,
                padding: 2,
                borderRadius: "8px",
                width: "284px",
                height: { lg: "240px", md: "240px", sm: "310px", xs: "240px" },
              }}
            >
              <img src={icon_1} />
              <H4>
                400+ Catering Partner <br /> from different cities
              </H4>
              <P
                sx={{
                  fontSize: "14px",
                  color: "#545359;",
                  textAlign: "justify",
                }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum is simply dummy text of the printing and
                typesetting industry.{" "}
              </P>
            </Card>
          </Slider>
        </Box>
      </Box>
    </>
  );
}

export default Our_Partner;
